import React, { useState } from 'react';

export const AccordionPreview = ({ component, onClick, isSelected }) => {
  const { commonAttrs, specificAttrs } = component;
  const { items } = specificAttrs || {};
  const [expandedIndex, setExpandedIndex] = useState(0);
  const itemsArray = (items || 'Section 1:Content 1,Section 2:Content 2').split(',').map(item => {
    const [title, content] = item.split(':');
    return { title: title?.trim() || 'Title', content: content?.trim() || 'Content' };
  });
  
  const containerStyle = {
    padding: `${commonAttrs?.paddingTop || 16}px ${commonAttrs?.paddingRight || 16}px ${commonAttrs?.paddingBottom || 16}px ${commonAttrs?.paddingLeft || 16}px`,
    margin: `${commonAttrs?.marginTop || 8}px ${commonAttrs?.marginRight || 0}px ${commonAttrs?.marginBottom || 8}px ${commonAttrs?.marginLeft || 0}px`,
    width: commonAttrs?.width === 'auto' ? 'auto' : `${commonAttrs?.width || 100}%`,
    cursor: onClick ? 'pointer' : 'default',
    border: isSelected ? '2px solid #3B82F6' : '2px solid transparent',
    borderRadius: '4px'
  };
  
  return (
    <div style={containerStyle} onClick={onClick}>
      <div>
      {itemsArray.map((item, idx) => (
        <div key={idx} style={{ borderBottom: '1px solid #E5E7EB' }}>
          <button
            onClick={() => setExpandedIndex(expandedIndex === idx ? -1 : idx)}
            style={{
              width: '100%',
              padding: '12px',
              background: '#F9FAFB',
              border: 'none',
              textAlign: 'left',
              fontSize: '14px',
              fontWeight: '600',
              cursor: 'pointer',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}
          >
            {item.title}
            <span>{expandedIndex === idx ? '−' : '+'}</span>
          </button>
          {expandedIndex === idx && (
            <div style={{ padding: '12px', fontSize: '14px', background: '#FFFFFF' }}>
              {item.content}
            </div>
          )}
        </div>
      ))}
      </div>
    </div>
  );
};
